import { type FieldPolicy } from "@apollo/client";

import {
    MyLensesSortDirection,
    type Query,
    type QueryGetMyLensesLensesArgs,
    SortBy,
} from "../../../gql-generated/types";

import { type LensesReference, mergeLenses } from "./mergeLenses";

const CACHE_UNSET_KEY = "UNSET";

export const cacheLensesConfig: Partial<Record<keyof Query, FieldPolicy<LensesReference>>> = {
    getMyLensesLenses: {
        keyArgs: (args) => {
            const {
                input: {
                    filterBy = { unlockableIdList: [], lockedList: [], nameList: [], statusList: [] },
                    sortBy = SortBy.SortByUnset,
                    sortDirection = MyLensesSortDirection.SortDirectionUnset,
                },
            } = args as QueryGetMyLensesLensesArgs;

            if (filterBy?.unlockableIdList && filterBy.unlockableIdList.length > 0) {
                return filterBy.unlockableIdList.toString();
            }

            const statusKey =
                filterBy?.statusList && filterBy.statusList.length > 0
                    ? filterBy.statusList.join(",")
                    : CACHE_UNSET_KEY;
            const [searchKey] =
                filterBy?.nameList && filterBy.nameList.length > 0 ? filterBy.nameList : [CACHE_UNSET_KEY];
            const [lockedKey] =
                filterBy?.lockedList && filterBy.lockedList.length > 0 ? filterBy.lockedList : [CACHE_UNSET_KEY];
            const filterKey = `${searchKey}:${String(lockedKey)}:${statusKey}`;

            return `${filterKey}:${sortBy}:${sortDirection}`;
        },
        merge: mergeLenses,
    },
};
